export interface VideoItem {
  id: number;
  title: string;
  category: string;
  categoryName: string;
  brand: string;
  image: string;
  description: string;
  rating: number;
  year: number;
  duration: string;
  tags: string[];
  views: number;
  isHot: boolean;
  isNew: boolean;
  detailContent: string;
  director: string;
  actors: string[];
}

export const videos: VideoItem[] = [
  {
    id: 1,
    title: "流浪地球3：星辰大海",
    category: "movie",
    categoryName: "电影",
    brand: "香蕉视频",
    image: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20astronauts%20in%20space%20suits%20looking%20at%20a%20massive%20planet%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20orange%20and%20teal%20color%20grading%2C%20movie%20poster%20style%20with%20Chinese%20text%20space&width=600&height=800&seq=video-001&orientation=portrait",
    description: "人类文明在浩瀚宇宙中寻找新的家园，面对未知的星际挑战，宇航员们踏上了一场前所未有的冒险之旅。",
    rating: 9.2,
    year: 2026,
    duration: "148分钟",
    tags: ["科幻", "冒险", "灾难"],
    views: 12890000,
    isHot: true,
    isNew: false,
    detailContent: "《流浪地球3：星辰大海》延续了前作的宏大叙事，讲述了人类在宇宙中继续寻找新家园的壮丽旅程。本片由郭帆执导，刘德华、吴京等主演，耗资超过10亿人民币，采用最先进的视觉特效技术，呈现了震撼人心的太空场景。影片在全球超过50个国家和地区同步上映，首周票房突破30亿人民币，成为2026年最受期待的科幻巨制。故事围绕地球派与飞船派的分歧展开，深入探讨了人类文明在面对宇宙级挑战时的抉择与团结。",
    director: "郭帆",
    actors: ["刘德华", "吴京", "李雪健", "王智"]
  },
  {
    id: 2,
    title: "长安十二时辰续",
    category: "tv",
    categoryName: "电视剧",
    brand: "蜜桃视频",
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20drama%20poster%20with%20warriors%20in%20traditional%20armor%20in%20ancient%20city%2C%20warm%20golden%20lighting%2C%20historical%20epic%20style%2C%20cinematic%20composition%2C%20movie%20poster%20design&width=600&height=800&seq=video-002&orientation=portrait",
    description: "盛唐时期，长安城中暗流涌动，一场关乎帝国命运的惊天阴谋正在悄然展开。",
    rating: 9.5,
    year: 2026,
    duration: "40集",
    tags: ["古装", "悬疑", "历史"],
    views: 25600000,
    isHot: true,
    isNew: true,
    detailContent: "《长安十二时辰续》作为爆款剧集的续作，延续了前作精良的制作水准。本剧由曹盾执导，雷佳音、易烊千玺主演，耗资巨大还原了盛唐长安的繁华景象。故事设定在前作数年之后，新的危机再次降临长安城，张小敬与李必再度联手，揭开隐藏在市井之中的惊天阴谋。全剧共40集，每集制作精良，服化道考究，堪称国产剧集的新标杆。",
    director: "曹盾",
    actors: ["雷佳音", "易烊千玺", "周一围", "热依扎"]
  },
  {
    id: 3,
    title: "快乐大本营·重启季",
    category: "variety",
    categoryName: "综艺",
    brand: "西瓜视频",
    image: "https://readdy.ai/api/search-image?query=Bright%20colorful%20variety%20show%20poster%20with%20hosts%20laughing%20on%20stage%2C%20confetti%20and%20lights%2C%20energetic%20atmosphere%2C%20bold%20vibrant%20colors%2C%20TV%20show%20promotional%20poster%20style&width=600&height=800&seq=video-003&orientation=portrait",
    description: "经典综艺节目全新回归，欢乐不停歇，明星嘉宾齐聚一堂带来满满笑料。",
    rating: 8.9,
    year: 2026,
    duration: "更新至第12期",
    tags: ["综艺", "搞笑", "明星"],
    views: 18900000,
    isHot: true,
    isNew: true,
    detailContent: "《快乐大本营·重启季》是这档陪伴观众二十余年的经典综艺的全新回归。新一季节目在保留经典游戏环节的基础上，加入了更多创新互动玩法。何炅领衔的全新主持阵容，每周邀请当红明星参与录制，为观众带来欢乐与感动。本节目的回归标志着中国综艺节目市场的新活力，首期节目收视率即创下同时段新高。",
    director: "刘伟",
    actors: ["何炅", "谢娜", "李维嘉", "吴昕"]
  },
  {
    id: 4,
    title: "深海秘境·鲸落",
    category: "documentary",
    categoryName: "纪录片",
    brand: "蓝莓视频",
    image: "https://readdy.ai/api/search-image?query=Stunning%20underwater%20documentary%20poster%20with%20whale%20swimming%20in%20deep%20blue%20ocean%2C%20sunlight%20rays%20penetrating%20water%2C%20mysterious%20and%20beautiful%20marine%20life%2C%20nature%20documentary%20style&width=600&height=800&seq=video-004&orientation=portrait",
    description: "潜入深海，见证地球上最神秘的生态系统，探索鲸落奇观背后的生命奇迹。",
    rating: 9.7,
    year: 2026,
    duration: "6集",
    tags: ["自然", "海洋", "科普"],
    views: 8900000,
    isHot: false,
    isNew: true,
    detailContent: "《深海秘境·鲸落》是一部由中国顶尖纪录片团队历时三年拍摄的史诗级海洋纪录片。摄制组深入太平洋、印度洋等海域，首次完整记录了鲸落生态系统的形成与演变过程。影片采用8K超高清水下摄影技术，捕捉到了前所未有的深海画面。每一帧画面都堪称艺术品，配合著名作曲家谭盾的原创配乐，为观众呈现了一场视听盛宴。该片在多个国际纪录片电影节上获得大奖。",
    director: "陆川",
    actors: ["旁白：陈道明"]
  },
  {
    id: 5,
    title: "斗罗大陆：神界传说",
    category: "anime",
    categoryName: "动漫",
    brand: "芒果视频",
    image: "https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20poster%20with%20warriors%20in%20fantasy%20armor%20with%20magical%20effects%2C%20epic%20fantasy%20style%2C%20glowing%20spirit%20rings%2C%20dramatic%20dynamic%20composition&width=600&height=800&seq=video-005&orientation=portrait",
    description: "唐三带领史莱克七怪飞升神界，面对诸神之战，守护斗罗大陆的终极决战。",
    rating: 9.3,
    year: 2026,
    duration: "更新至第78集",
    tags: ["玄幻", "热血", "冒险"],
    views: 35600000,
    isHot: true,
    isNew: false,
    detailContent: "《斗罗大陆：神界传说》延续了斗罗系列的辉煌，由玄机科技倾力打造。动画制作水准全面升级，采用了最新的虚幻引擎5渲染技术，画面精细度达到电影级别。剧情方面，唐三带领史莱克七怪进入神界，面对更强大的敌人和更复杂的神界政治格局。每集时长25分钟，每周六更新，持续霸占国产动画热度榜首。",
    director: "沈乐平",
    actors: ["配音：张杰", "配音：季冠霖", "配音：山新"]
  },
  {
    id: 6,
    title: "黄昏旅店",
    category: "movie",
    categoryName: "电影",
    brand: "樱桃视频",
    image: "https://readdy.ai/api/search-image?query=Artistic%20mystery%20film%20poster%20of%20a%20vintage%20hotel%20at%20sunset%20with%20warm%20golden%20light%2C%20silhouettes%20of%20guests%2C%20atmospheric%20and%20mysterious%2C%20indie%20film%20aesthetic&width=600&height=800&seq=video-006&orientation=portrait",
    description: "一间神秘的旅店，几位陌生旅客的偶然相遇，揭开了一段尘封数十年的往事。",
    rating: 8.7,
    year: 2026,
    duration: "132分钟",
    tags: ["悬疑", "剧情", "文艺"],
    views: 6700000,
    isHot: false,
    isNew: true,
    detailContent: "《黄昏旅店》是一部精心雕琢的悬疑剧情片，由新锐导演陈思诚执导。影片以一栋建于民国时期的古老旅店为舞台，讲述了五位来自不同背景的旅客在暴风雨之夜被困旅店，逐渐发现彼此之间存在着意想不到的联系。影片采用非线性叙事结构，环环相扣的剧情设计令观众欲罢不能。精良的美术设计和摄影获得了影评人的一致好评。",
    director: "陈思诚",
    actors: ["张译", "周冬雨", "段奕宏", "谭卓"]
  },
  {
    id: 7,
    title: "舌尖上的中国·世界篇",
    category: "documentary",
    categoryName: "纪录片",
    brand: "草莓视频",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20food%20documentary%20poster%20with%20various%20Chinese%20cuisines%20from%20around%20the%20world%2C%20steaming%20dishes%2C%20rich%20warm%20colors%2C%20appetizing%20food%20photography%20style&width=600&height=800&seq=video-007&orientation=portrait",
    description: "走遍全球，探寻中华美食在世界各地的演变与传承，品味家的味道。",
    rating: 9.6,
    year: 2026,
    duration: "8集",
    tags: ["美食", "文化", "旅行"],
    views: 14500000,
    isHot: true,
    isNew: false,
    detailContent: "《舌尖上的中国·世界篇》将镜头对准全球各地的华人社区，记录中华美食在世界各地的演变与传承。从纽约唐人街的早茶到巴黎的中餐馆，从东南亚的潮汕美食到非洲的中国农场，摄制组跨越六大洲，用美食串联起全球华人的共同记忆。每一道菜肴背后都有一个关于迁徙、适应与传承的故事，让观众在味蕾的牵引下感受文化的流动。",
    director: "陈晓卿",
    actors: ["旁白：李立宏"]
  },
  {
    id: 8,
    title: "熊出没·星际冒险",
    category: "kids",
    categoryName: "少儿",
    brand: "柠檬视频",
    image: "https://readdy.ai/api/search-image?query=Cute%20animated%20movie%20poster%20with%20bears%20in%20space%20suits%20exploring%20colorful%20alien%20planet%2C%20children%20animation%20style%2C%20bright%20playful%20colors%2C%20family%20friendly&width=600&height=800&seq=video-008&orientation=portrait",
    description: "熊大熊二和光头强意外飞入太空，在星际间展开一场妙趣横生的冒险。",
    rating: 8.5,
    year: 2026,
    duration: "95分钟",
    tags: ["动画", "喜剧", "冒险", "亲子"],
    views: 22000000,
    isHot: false,
    isNew: true,
    detailContent: "《熊出没·星际冒险》是熊出没系列的第11部大电影，也是系列首次涉足太空题材。影片讲述了熊大、熊二和光头强意外乘坐飞船进入太空，在陌生的星球上遇到外星朋友，并一同对抗宇宙海盗的故事。本片制作水准全面升级，采用了先进的动画渲染技术，画面色彩鲜艳，角色动作流畅自然。适合全家一起观看的优质国产动画电影。",
    director: "丁亮",
    actors: ["配音：张伟", "配音：张秉君", "配音：谭笑"]
  },
  {
    id: 9,
    title: "三体：黑暗森林",
    category: "movie",
    categoryName: "电影",
    brand: "葡萄视频",
    image: "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20sci-fi%20movie%20poster%20with%20mysterious%20cosmic%20phenomenon%2C%20stars%20forming%20patterns%2C%20cold%20dark%20blue%20and%20black%20tones%2C%20philosophical%20sci-fi%20aesthetic&width=600&height=800&seq=video-009&orientation=portrait",
    description: "宇宙社会学揭示黑暗森林法则，人类文明面临前所未有的生存危机。",
    rating: 9.4,
    year: 2026,
    duration: "165分钟",
    tags: ["科幻", "悬疑", "哲学"],
    views: 31000000,
    isHot: true,
    isNew: true,
    detailContent: "《三体：黑暗森林》改编自刘慈欣同名科幻巨著，是继第一部之后的全新力作。影片由张艺谋执导，集结了国内外顶级制作团队。影片深入探讨了宇宙社会学的核心概念——黑暗森林法则，通过宏大的视觉呈现和深刻的思想内涵，展现了人类文明在得知宇宙真相后的挣扎与抉择。耗资20亿人民币打造的视觉奇观，将中国科幻电影推向了新的高度。",
    director: "张艺谋",
    actors: ["张涵予", "李现", "陈道明", "周迅"]
  },
  {
    id: 10,
    title: "武林外传·归来",
    category: "tv",
    categoryName: "电视剧",
    brand: "荔枝视频",
    image: "https://readdy.ai/api/search-image?query=Chinese%20period%20comedy%20drama%20poster%20with%20group%20of%20colorful%20characters%20in%20traditional%20inn%2C%20warm%20humorous%20atmosphere%2C%20nostalgic%20TV%20series%20style&width=600&height=800&seq=video-010&orientation=portrait",
    description: "同福客栈重新开张，老朋友们再次相聚，新的故事在欢声笑语中展开。",
    rating: 9.1,
    year: 2026,
    duration: "36集",
    tags: ["喜剧", "古装", "情怀"],
    views: 19800000,
    isHot: false,
    isNew: true,
    detailContent: "《武林外传·归来》是经典情景喜剧的20周年回归之作。原班人马悉数回归，闫妮、姚晨、沙溢等主演再度聚首同福客栈。新一季故事设定在原作20年后，佟湘玉和白展堂的女儿接管了客栈，老朋友们带着各自的人生经历重新回到这个充满回忆的地方。剧集在保留经典幽默风格的同时，融入了新时代的元素，既让老观众感动落泪，也吸引了新一代的年轻观众。",
    director: "尚敬",
    actors: ["闫妮", "姚晨", "沙溢", "喻恩泰"]
  },
  {
    id: 11,
    title: "乘风破浪的姐姐·巅峰季",
    category: "variety",
    categoryName: "综艺",
    brand: "西瓜视频",
    image: "https://readdy.ai/api/search-image?query=Glamorous%20variety%20show%20poster%20with%20elegant%20women%20in%20stunning%20dresses%20on%20stage%2C%20spotlight%20effects%2C%20empowering%20atmosphere%2C%20luxurious%20golden%20and%20red%20tones&width=600&height=800&seq=video-011&orientation=portrait",
    description: "巅峰赛季，华语乐坛顶级女艺人齐聚，用舞台点燃无限可能。",
    rating: 9.0,
    year: 2026,
    duration: "更新至第8期",
    tags: ["音乐", "竞技", "女性"],
    views: 28900000,
    isHot: true,
    isNew: false,
    detailContent: "《乘风破浪的姐姐·巅峰季》汇聚了华语乐坛最具影响力的30位女艺人，从经典歌后到新生代偶像，横跨数个世代。本季节目在赛制和舞台设计上全面升级，邀请国际顶级舞台导演参与制作。姐姐们在节目中挑战自我，突破舒适圈，用一个个精彩的舞台表演诠释了女性力量的无限可能。节目不仅是一场比赛，更是一场关于梦想与坚持的动人叙事。",
    director: "吴梦知",
    actors: ["宁静", "那英", "王菲", "蔡依林"]
  },
  {
    id: 12,
    title: "进击的巨人·终章·后篇",
    category: "anime",
    categoryName: "动漫",
    brand: "芒果视频",
    image: "https://readdy.ai/api/search-image?query=Epic%20anime%20poster%20with%20giant%20titans%20and%20soldiers%20in%20dramatic%20battle%2C%20dark%20atmospheric%20sky%2C%20cinematic%20anime%20art%20style%2C%20intense%20action%20composition&width=600&height=800&seq=video-012&orientation=portrait",
    description: "最终决战，艾伦与同伴们的命运在此交汇，人类与巨人的战争迎来终局。",
    rating: 9.8,
    year: 2026,
    duration: "85分钟",
    tags: ["热血", "战斗", "剧情"],
    views: 42000000,
    isHot: true,
    isNew: true,
    detailContent: "《进击的巨人·终章·后篇》是这部现象级动画的最终章，为长达十年的史诗故事画上句号。MAPPA工作室倾力打造，画面表现力达到系列巅峰。影片涵盖了原作漫画最终卷的全部内容，以震撼的视觉效果和深刻的情感表达，完成了艾伦·耶格尔的完整角色弧光。电影在日本上映首周即打破票房纪录，全球粉丝翘首以盼的终极盛宴。",
    director: "林祐一郎",
    actors: ["配音：梶裕贵", "配音：石川由依", "配音：井上麻里奈"]
  },
  {
    id: 13,
    title: "喜剧之王2",
    category: "movie",
    categoryName: "电影",
    brand: "葡萄视频",
    image: "https://readdy.ai/api/search-image?query=Heartwarming%20comedy%20film%20poster%20with%20young%20actor%20on%20stage%20spotlight%2C%20dreamy%20cinematic%20lighting%2C%20inspirational%20and%20touching%20atmosphere%2C%20warm%20nostalgic%20tones&width=600&height=800&seq=video-013&orientation=portrait",
    description: "新一代追梦人的喜剧之路，笑中带泪的温暖故事再次上演。",
    rating: 8.6,
    year: 2026,
    duration: "128分钟",
    tags: ["喜剧", "剧情", "励志"],
    views: 15600000,
    isHot: false,
    isNew: false,
    detailContent: "《喜剧之王2》是周星驰经典作品的精神续作，由新生代导演执导，讲述了在短视频时代，一位普通年轻人坚持喜剧梦想的故事。影片在致敬经典的同时，融入了当下社会的现实议题，以温暖幽默的方式展现了普通人在追梦路上的酸甜苦辣。片中对喜剧行业的真实描绘引发广泛共鸣，被誉为2026年最打动人心的国产喜剧片。",
    director: "大鹏",
    actors: ["沈腾", "马丽", "魏翔", "张小斐"]
  },
  {
    id: 14,
    title: "动物世界·非洲草原篇",
    category: "kids",
    categoryName: "少儿",
    brand: "柠檬视频",
    image: "https://readdy.ai/api/search-image?query=Colorful%20children%20nature%20documentary%20poster%20with%20cute%20African%20animals%20lion%20elephant%20giraffe%20on%20savanna%2C%20bright%20sunny%20colors%2C%20educational%20and%20fun&width=600&height=800&seq=video-014&orientation=portrait",
    description: "带领小朋友走进非洲大草原，认识各种神奇的野生动物。",
    rating: 9.0,
    year: 2026,
    duration: "26集",
    tags: ["自然", "科普", "亲子", "动画"],
    views: 9800000,
    isHot: false,
    isNew: false,
    detailContent: "《动物世界·非洲草原篇》是专为3-10岁儿童打造的科普动画系列。节目采用可爱的3D动画形式，带领小朋友们走进非洲大草原，近距离观察狮子、大象、长颈鹿等野生动物的生活习性。每集10分钟，内容浅显易懂，寓教于乐。节目邀请著名配音演员录制旁白，用温柔有趣的语言讲述动物们的故事，培养孩子们对自然的热爱和保护意识。",
    director: "王云飞",
    actors: ["配音：刘纯燕"]
  },
  {
    id: 15,
    title: "密室大逃脱·终极季",
    category: "variety",
    categoryName: "综艺",
    brand: "蜜桃视频",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20escape%20room%20variety%20show%20poster%20with%20dim%20dramatic%20lighting%2C%20puzzle%20elements%2C%20suspenseful%20atmosphere%2C%20dark%20theatrical%20style&width=600&height=800&seq=video-015&orientation=portrait",
    description: "终极密室挑战，明星嘉宾在极限恐惧中突破自我，解锁惊天谜题。",
    rating: 8.8,
    year: 2026,
    duration: "更新至第10期",
    tags: ["推理", "悬疑", "真人秀"],
    views: 17600000,
    isHot: false,
    isNew: true,
    detailContent: "《密室大逃脱·终极季》打造了史上最大规模的实景密室，耗资数千万在废弃工厂基础上改建而成。本季节目引入全新赛制，嘉宾们需要在72小时内连续闯关，体力与智力的双重考验让节目紧张感拉满。邓伦、杨幂等原班人马回归，新加入的飞行嘉宾也为节目增添了更多精彩看点。",
    director: "何忱",
    actors: ["邓伦", "杨幂", "黄明昊", "大张伟"]
  },
  {
    id: 16,
    title: "琅琊榜之风起长林·续",
    category: "tv",
    categoryName: "电视剧",
    brand: "樱桃视频",
    image: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20historical%20drama%20poster%20with%20noble%20warriors%20in%20flowing%20robes%2C%20ink%20wash%20painting%20aesthetic%2C%20refined%20and%20artistic%20composition&width=600&height=800&seq=video-016&orientation=portrait",
    description: "朝堂之上的权力博弈，江湖之中的侠义情怀，延续经典传奇。",
    rating: 9.3,
    year: 2026,
    duration: "48集",
    tags: ["古装", "权谋", "武侠"],
    views: 23400000,
    isHot: true,
    isNew: false,
    detailContent: "《琅琊榜之风起长林·续》延续了琅琊榜系列一贯的高品质制作。本剧由孔笙执导，黄晓明、刘昊然主演，讲述了大梁王朝新一代谢侯在朝堂与江湖之间力挽狂澜的故事。精良的服化道、考究的历史细节、扣人心弦的权谋剧情，延续了正午阳光出品的金牌口碑。全剧48集，每集都堪称艺术品级别的视觉享受。",
    director: "孔笙",
    actors: ["黄晓明", "刘昊然", "佟丽娅", "张慧雯"]
  }
];

export const featuredHeroVideos = [1, 2, 3, 5, 11, 12];

export function getVideosByCategory(slug: string): VideoItem[] {
  if (slug === "all") return videos;
  return videos.filter((v) => v.category === slug);
}

export function getVideoById(id: number): VideoItem | undefined {
  return videos.find((v) => v.id === id);
}

export function getHotVideos(): VideoItem[] {
  return videos.filter((v) => v.isHot);
}

export function getNewVideos(): VideoItem[] {
  return videos.filter((v) => v.isNew);
}

export function getRelatedVideos(id: number, limit: number = 4): VideoItem[] {
  const current = getVideoById(id);
  if (!current) return [];
  return videos
    .filter((v) => v.id !== id && v.category === current.category)
    .slice(0, limit);
}